<template>
  <ClientOnly>
    <button
      type="button"
      :title="title"
      :aria-label="title"
      class="relative inline-flex items-center justify-center w-8 h-8 rounded-sm cursor-pointer transition-colors"
      :class="triggerClass"
      @click="toggle"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        class="absolute w-[18px] h-[18px] transition-opacity duration-200"
        :class="isDark ? 'opacity-0' : 'opacity-100'"
      >
        <circle cx="12" cy="12" r="4" />
        <path d="M12 3v2.25M12 18.75V21M5.25 12H3M21 12h-2.25M5.636 5.636l1.591 1.591M16.773 16.773l1.591 1.591M5.636 18.364l1.591-1.591M16.773 7.227l1.591-1.591" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        class="absolute w-[18px] h-[18px] transition-opacity duration-200"
        :class="isDark ? 'opacity-100' : 'opacity-0'"
      >
        <path d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
      </svg>
    </button>
  </ClientOnly>
</template>

<script setup>
const props = defineProps({
  variant: {
    type: String,
    default: "dark",
    validator: (v) => ["dark", "light"].includes(v),
  },
});

const { t } = useI18n();
const colorMode = useColorMode();

const isDark = computed(() => colorMode.value === "dark");

const title = computed(() =>
  isDark.value
    ? t("controls.theme.switchToLight")
    : t("controls.theme.switchToDark")
);

const triggerClass = computed(() =>
  props.variant === "dark"
    ? "text-slate-300 hover:text-amber-400 hover:bg-slate-800/60 focus-visible:outline-1 focus-visible:outline focus-visible:outline-amber-400/60 focus-visible:outline-offset-2"
    : "text-slate-700 dark:text-slate-200 hover:text-amber-500 hover:bg-slate-100 dark:hover:bg-slate-800 focus-visible:outline-1 focus-visible:outline focus-visible:outline-amber-500/60 focus-visible:outline-offset-2"
);

const toggle = () => {
  colorMode.preference = isDark.value ? "light" : "dark";
};
</script>
